module.exports = __webpack_public_path__ + "static/media/knob4.c2cb266a.png";